import { render, staticRenderFns } from "./SCardLotComp.vue?vue&type=template&id=4e702023&"
import script from "./SCardLotComp.vue?vue&type=script&lang=js&"
export * from "./SCardLotComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports